export const TEXT = {
  TITLE: {
    id: 'head.title.user_area',
    defaultMessage: 'Lookiero | Your Personal Shopper online',
  },
};
